<template>
  <div
    class="portfolio-pages-wrapper section-space--ptb_100 border-bottom gray-gradient"
  >
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div
            class="section-title-wrapper text-center section-space--mb_60 wow move-up"
          >
            <h2 class="section-title font-weight--bold mb-15">Our Services</h2>
            <h6>
              We pride ourselves in being a multi-talented and broad team that
              can span across various ICT services some of which are listed
              hereunder.
            </h6>
          </div>
        </div>
      </div>
      <div class="row">
        <div
          class="col-lg-4 col-md-6 mb-30 wow move-up"
          v-for="(service, key) in services"
          :key="key"
        >
          <div class="portfolio-grid-caption text-center">
            <router-link to="/portfolio-details" class="single-grid-caption">
              <div class="single-portfolio__thumbnail">
                <img
                  class="img-fluid"
                  :src="service.image"
                  :alt="service.name"
                />
              </div>
            </router-link>
            <div class="post-info">
              <div class="post-categories">
                <router-link to="">{{ service.name }}</router-link>
              </div>
              <h5 class="post-title font-weight--bold">
                <router-link to="">
                  {{ service.name }}
                </router-link>
              </h5>
            </div>
            <div class="load-more-button text-center">
              <button class="ht-btn ht-btn-md ht-btn--outline loadMore">
                <router-link
                  :to="{
                    name: 'contact-us',
                    query: { subject: service.name },
                  }"
                >
                  Enquire
                </router-link>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import services from "../data/services";

export default {
  components: {},

  data() {
    return {
      services,
    };
  },
};
</script>
